import React from 'react';
import moment from 'jalali-moment';
import { Link } from 'react-router-dom';
import Content from '../dashboard/Content';
import Dialog from '../../toolkit/dialog';
import LogService from '../../services/log-service';
import DeviceService from '../../services/device-service';
import PrintDescriptionDialog from './PrintDescriptionDialog';
import print from '../../utils/print';
import findSensorUnitByType from '../../utils/unit';
import { decode } from '../../utils/html-entity';
import { range } from '../../utils/easy';
import { Switch } from '../widgets/beauty/input';
import { LogData } from '../interfaces';
import { exportFromHtml } from '../../utils/excel';
import * as chartModule from '../../utils/chartjs';

import './GraphPage.scss';

moment.locale('fa');

const iranianMonth = [
  'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
  'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
];

export interface GraphPageProps {
  match: {
    params: {
      device: string
    }
  }
}

export interface GraphPageState {
  day: number | string | null;
  month: number | string;
  year: number | string;
  interval: number | string;
  logs: LogData[][];
  device: any;
  showMonth: boolean;
  nextDeviceId: string | null;
  prevDeviceId: string | null;
  redirect: string;
}


export default class GraphPage extends React.Component<GraphPageProps, GraphPageState> {

  private chart: Chart[] = [];
  private currentMoment = moment();

  private logService = new LogService();
  private deviceService = new DeviceService();
  private baseState: GraphPageState;

  state = {
    logs: [undefined, undefined, undefined, undefined],
    day: Number(this.currentMoment.format('jDD')),
    month: Number(this.currentMoment.format('jMM')),
    year: Number(this.currentMoment.format('jYYYY')),
    interval: 180,
    device: null,
    showMonth: true,
    nextDeviceId: null,
    prevDeviceId: null
  } as GraphPageState;


  constructor(props: GraphPageProps) {
    super(props);
    const search = new URLSearchParams((props as any).location.search);
    const day = Number(search.get('day') ?? undefined);
    const month = Number(search.get('month') ?? undefined);
    const year = Number(search.get('year') ?? undefined);
    if (!Number.isNaN(day)) {
      this.state.day = day;
    }
    if (!Number.isNaN(month)) {
      this.state.month = month;
    }
    if (!Number.isNaN(year)) {
      this.state.year = year;
    }
    this.baseState = this.state;
  }

  render() {
    // const { year, month, day, showMonth, interval, device, nextDeviceId, prevDeviceId } = this.state;
    const { year, month, day, showMonth, interval } = this.state;
    const serial = this.props.match.params.device;
    const editUrl = '/dashboard/devices/edit/' + serial;
    const navText = this.state.showMonth ? 'ماه' : 'روز';
    return (
      <Content title={"خانه / گراف دستگاه " + serial}>
        <div className="component-graph-page">
          <div className="row">
            <div className="col-md-12 col-12">
              <Link to={editUrl} className="btn btn-outline-app settings-btn">
                <i className="far fa-cog" style={{ fontSize: '1.1rem' }}></i>
                <span>تنظیمات دستگاه</span>
              </Link>
            </div>
            <hr style={{ width: '100%' }} />
          </div>
          <div className="row">
            <div className="d-flex flex-row graph-month-switch mx-auto ltr mb-3">
              <span className="mr-2">روزانه</span>
              <Switch
                text="ماهانه"
                checked={showMonth}
                onChange={this.handleShowMonthChange}
                active={{ color: '#3498db', borderColor: '#3498db' }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-12">
              <div className="form-group">
                <label>انتخاب سال</label>
                <select
                  className="input-app"
                  onChange={this.handleYearChage}
                  value={year}>
                  {range(1390, Number(year) + 1).reverse().map(y =>
                    <option key={y} value={y}>{y}</option>
                  )}
                </select>
              </div>
            </div>
            <div className="col-md-3 col-12">
              <div className="form-group">
                <label>انتخاب ماه</label>
                <select
                  className="input-app"
                  onChange={this.handleMonthChage}
                  value={month}>
                  {iranianMonth.map((m, index) => (
                    <option key={index} value={index + 1}>{m}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-3 col-12">
              <div className="form-group">
                <label style={showMonth ? { color: '#999' } : {}}>انتخاب روز</label>
                <select
                  {...(showMonth ? { disabled: true } : {})}
                  value={day}
                  className="input-app"
                  onChange={this.handleDayChange}>
                  {range(1, (Number(month) > 6) ? 31 : 32).map(d =>
                    <option key={d} value={d}>{d}</option>
                  )}
                </select>
              </div>
            </div>
            <div className="col-md-3 col-12">
              <div className="form-group">
                <label>میانگین</label>
                <select className="input-app" value={interval} onChange={this.handleIntervalChange}>
                  {this.renderInterval()}
                </select>
              </div>
            </div>
            {(!showMonth) ? '' : <div className="col-md-3 col-12"></div>}
            <div className="col-md-3 col-12 mr-auto">
              <div className="form-group d-flex align-items-end">
                <button
                  onClick={this.handleApplyFilter}
                  className="btn btn-app btn-app-sm btn-block">اعمال فیلتر</button>
              </div>
            </div>
          </div>
          <div className="canvas-container">
            <canvas dir="rtl" id="graph-canvas-0" width="100%" style={{ padding: '20px', paddingBottom: 0 }}></canvas>
            <div id="canvas-footer-0" className="canvas-footer">
              {this.renderGraphFooter(0)}
            </div>
          </div>
          <div className="canvas-container">
            <canvas dir="rtl" id="graph-canvas-1" width="100%" style={{ padding: '20px', paddingBottom: 0 }}></canvas>
            <div id="canvas-footer-1" className="canvas-footer">
              {this.renderGraphFooter(1)}
            </div>
          </div>
          <div className="canvas-container">
            <canvas dir="rtl" id="graph-canvas-2" width="100%" style={{ padding: '20px', paddingBottom: 0 }}></canvas>
            <div id="canvas-footer-2" className="canvas-footer">
              {this.renderGraphFooter(2)}
            </div>
          </div>
          <div className="canvas-container">
            <canvas dir="rtl" id="graph-canvas-3" width="100%" style={{ padding: '20px', paddingBottom: 0 }}></canvas>
            <div id="canvas-footer-3" className="canvas-footer">
              {this.renderGraphFooter(3)}
            </div>
          </div>
          <div className="text-center mt-3">
            {/* <Link to={"/dashboard/graph/" + nextDeviceId}
              onClick={() => { this.resetComponent() }}
              className={"btn btn-app inline-flex-center ml-1 " + (nextDeviceId == null ? 'disabled' : '')}>
              <i className="far fa-angle-double-right"></i>
              <span className="mr-2">دستگاه بعدی</span>
            </Link> */}
            <button
              {...this.isNextButtonDisabled()}
              className="btn btn-app inline-flex-center ml-2"
              onClick={this.handleNextContextClicked}>
              <i className="far fa-angle-right"></i>
              <span className="mr-2">{navText} بعد</span>
            </button>
            <button className="btn btn-app inline-flex-center mr-2" onClick={this.handlePrevContextClicked}>
              <span className="ml-2">{navText} قبل</span>
              <i className="far fa-angle-left"></i>
            </button>
            {/* <Link
              to={"/dashboard/graph/" + prevDeviceId}
              onClick={() => { this.resetComponent() }}
              className={"btn btn-app inline-flex-center mr-1 " + (prevDeviceId == null ? 'disabled' : '')}>
              <span className="ml-2">دستگاه قبلی</span>
              <i className="far fa-angle-double-left"></i>
            </Link> */}
          </div>
        </div>
      </Content>
    );
  }

  componentDidMount = async () => {
    const { year, month, day, interval, showMonth } = this.state;
    const serial = this.getDeviceSerial();
    const device = await this.deviceService.findById(serial);
    const logs = await this.logService.findByDeviceId(serial, { year, month, day, interval }, showMonth);
    this.setState({ logs: logs ?? [undefined, undefined, undefined, undefined], device });
    this.makeCanvas(device);
  }

  renderInterval = () => {
    if (this.state.showMonth) {
      return (
        <>
          <option value={120}>۲ ساعت</option>
          <option value={180}>۳ ساعت</option>
          <option value={360}>۶ ساعت</option>
          <option value={480}>۸ ساعت</option>
          <option value={720}>۱۲ ساعت</option>
          <option value={1440}>روزانه</option>
        </>
      );
    }
    return (
      <>
        <option value={15}>&nbsp;۱۵ دقیقه یکبار</option>
        <option value={60}>&nbsp;۱ ساعت یکبار</option>
        <option value={180}>&nbsp;۳ ساعت یکبار</option>
      </>
    );
  }

  renderGraphFooter = (index: number) => {
    const logs = this.state.logs[index] ?? [];
    const { device } = this.state;

    const sensorName = (device && device.sensors && device.sensors[index].name) ?
      device.sensors[index].name :
      `${index} - No name`;
    const data = logs.map(log => log.avg) as any[];
    const filtered = data.filter(d => d != null);
    const length = filtered.length;
    const max = (length === 0) ? 'بدون مقدار' : Math.max(...filtered);
    const min = (length === 0) ? 'بدون مقدار' : Math.min(...filtered);
    const { year, month, day, showMonth } = this.state;

    let dateString: string;
    if (showMonth) {
      dateString = moment
        .from(`${year}-${month}`, 'fa', 'jYYYY-jM')
        .format('jMMM jYYYY');
    }
    else {
      dateString = moment
        .from(`${year}-${month}-${day}`, 'fa', 'jYYYY-jM-jD')
        .format('jYYYY/jMM/jDD');
    }
    return (
      <div className="graph-info">
        <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span>گراف شماره {index}</span>
          <span>{sensorName}</span>
          <span>{dateString}</span>
        </div>
        <div style={{ marginTop: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>بیشترین مقدار: {max} | کمترین مقدار: {min}</div>
        <div className="text-center mt-3">
          {/* <Link to={"/dashboard/graph/" + nextDeviceId}
            onClick={() => { this.resetComponent() }}
            className={"btn btn-app inline-flex-center ml-1 " + (nextDeviceId == null ? 'disabled' : '')}>
            <i className="far fa-angle-double-right"></i>
            <span className="mr-2">دستگاه بعدی</span>
          </Link> */}
          <button
            onClick={this.handlePrintGraphClicked.bind(this, index)}
            className="btn btn-success d-inline-flex align-items-center mx-1">
            <i className="far fa-print ml-2"></i> پرینت گراف
          </button>
          <button
            onClick={this.exportExcel.bind(this, index)}
            className="btn btn-success d-inline-flex align-items-center mx-1">
            <i className="far fa-file-excel ml-2"></i> خروجی اکسل
          </button>
          {/* <Link
            to={"/dashboard/graph/" + prevDeviceId}
            onClick={() => { this.resetComponent() }}
            className={"btn btn-app inline-flex-center mr-1 " + (prevDeviceId == null ? 'disabled' : '')}>
            <span className="ml-2">دستگاه قبلی</span>
            <i className="far fa-angle-double-left"></i>
          </Link> */}
        </div>
      </div>
    );
  }

  private isNextButtonDisabled = () => {
    const { showMonth, year, month } = this.state;
    const day = Number(this.state.day);
    const currentYear = Number(moment().format('jYYYY'));
    if (showMonth) {
      if (month === 12 && year >= currentYear) {
        return { disabled: true };
      }
    }
    else {
      const time = moment.from(`${year}-${month}-${day}`, 'fa', 'jYYYY-jMM-jDD');
      time.add(1, 'day');
      if (Number(time.format('jYYYY')) > currentYear) {
        return { disabled: true };
      }
    }
    return {};
  }

  private handleDayChange = (e: any) => this.setState({
    day: e.target.value,
    interval: e.target.value === '' ? 180 : 60
  });

  private handleMonthChage = (e: any) => this.setState({ month: e.target.value });

  private handleYearChage = (e: any) => this.setState({ year: e.target.value });

  private handleIntervalChange = (e: any) => this.setState({ interval: e.target.value });

  private handleApplyFilter = () => this.componentDidMount();

  private handleShowMonthChange = (e) => {
    const showMonth = !this.state.showMonth;
    // const day = showMonth ? '' : Number(moment().format('jDD'));
    const interval = showMonth ? 180 : 15;
    this.setState({ showMonth, interval });
  }

  private handlePrevContextClicked = () => {
    const showMonth = this.state.showMonth;
    let year = Number(this.state.year);
    let month = Number(this.state.month);
    let day = Number(this.state.day);
    if (showMonth) {
      month--;
    }
    else {
      day--;
      if (day === 0) {
        day = month > 6 ? 30 : 31;
        month--;
      }
    }
    if (month === 0) {
      month = 12;
      year--;
    }
    if (showMonth) {
      this.setState({ year, month }, this.handleApplyFilter);
    }
    else {
      this.setState({ day, year, month }, this.handleApplyFilter);
    }
  }

  private handleNextContextClicked = () => {
    const showMonth = this.state.showMonth;
    let year = Number(this.state.year);
    let month = Number(this.state.month);
    let day = Number(this.state.day);

    if (showMonth) {
      month++;
    }
    else {
      day++;
      const maxDay = month > 6 ? 30 : 31;
      if (day > maxDay) {
        day = 1;
        month++;
      }
    }
    if (month >= 13) {
      day = 1;
      month = 1;
      year++;
    }

    if (showMonth) {
      this.setState({ year, month }, this.handleApplyFilter);
    }
    else {
      this.setState({ day, year, month }, this.handleApplyFilter);
    }
  }

  private makeCanvas = async (device: any) => {
    let { logs, showMonth, interval } = this.state;
    const unit = decode(findSensorUnitByType(device.type));
    for (let i = 0; i < logs.length; i++) {
      const sensorLogs = chartModule.provideDatasetGaps(logs[i], interval, showMonth);
      const sensor = device.sensors[i];
      const values = chartModule.extractValuesFromLogs(sensorLogs);
      const times = chartModule.extractTimesFromLogs(sensorLogs, showMonth);
      const disconnects = chartModule.provideDisconnects(sensorLogs);
      const datasets = chartModule.makeDatasets(device, {
        data: values,
        max: sensor.max1,
        min: sensor.min1,
        maxPhone: sensor.maxPhone,
        minPhone: sensor.minPhone,
        disconnects
      });
      if (!this.chart[i]) {
        this.chart[i] = chartModule.create({ id: 'graph-canvas-' + i, datasets, times, unit });
      }
      else {
        chartModule.update(this.chart[i], { datasets, times, unit: unit })
      }
    }

  }

  private getDeviceSerial = () => this.props.match.params.device;

  private handlePrintGraphClicked = (index: number) => {
    const { device } = this.state;
    new Dialog({
      rtl: true,
      title: 'برای درج توضیحات از کادر زیر استفاده کنید',
      size: 'small',
      message: PrintDescriptionDialog,
      onClose: (desc: string) => {
        print({
          canvasId: 'graph-canvas-' + index,
          title: device ? device.name : '',
          content: (
            document.getElementById('canvas-footer-' + index).innerHTML +
            `<br/><div style="text-align: center">${desc}</div>`
          ),
          stylesTags: [`
            button {display: none}
            .graph-info {
              font-size: 0.8rem;
              color: #555555;
              direction: rtl;
              text-align: center;
            }
            .graph-info span {
                display: inline-flex;
                padding: 0 0.3rem;
            }
          `]
        });
      }
    }).show();
  }

  private exportExcel = (index: number) => {
    const { logs, showMonth } = this.state;
    const values = chartModule.extractValuesFromLogs(logs[index]);
    const times = chartModule.extractTimesFromLogs(logs[index], showMonth);
    let content = '';
    for (let i = 0; i < values.length; i++) {
      content += `<tr><td>${times[i]}</td><td>${values[i]}</td></tr>`;
    }
    content = `<table><tbody>${content}</tbody></table>`;
    exportFromHtml(content);
  }

}
